export const SET_CURRENT_IMAGE_UPLOAD = 'SET_CURRENT_IMAGE_UPLOAD';
